export const DspX1DSWebLegacyThemeUsage = {
  light: {
    "nav-bar-background": "#FFFFFF",
    "web-wash": "#F0F2F5",
    "primary-text": "#050505",
    "primary-accent": "#0866FF",
    "border-line": "#D0D3D9",
  },
  dark: {
    "nav-bar-background": "#242526",
    "web-wash": "#18191A",
    "primary-text": "#E4E6EB",
    "primary-accent": "#0866FF",
    "border-line": "#3A3B3C",
  },
};
